/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { Box, Txt } from '.'
import {
  PlayingCardOption,
  PlayingCardRank,
  PlayingCardSuit,
} from '../sharedBetweenServerAndClient__DO_NOT_EDIT/types'
import _ from 'lodash'

const suitUnicodeMap = {
  d: '♦',
  h: '♥',
  c: '♣',
  s: '♠',
}

const suitColorMap = {
  d: 'red',
  h: 'red',
  c: 'font',
  s: 'font',
}

const rankOverridesMap: Partial<Record<PlayingCardRank, string>> = {
  T: '10',
}

export interface IPlayingCardProps {
  width: number | number[]
  height?: number | number[]
  card: PlayingCardOption
}

export const PLAYING_CARD_HEIGHT_WIDTH_RATIO = 1.4

export const PlayingCardContainer: React.SFC<Omit<IPlayingCardProps, 'card'>> = ({
  width,
  height,
  ...props
}) => (
  <Box
    sx={{
      width,
      height:
        height ||
        (_.isArray(width)
          ? (width as number[]).map((width) => width * PLAYING_CARD_HEIGHT_WIDTH_RATIO)
          : width * PLAYING_CARD_HEIGHT_WIDTH_RATIO),
      boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.15)',
      borderStyle: 'solid',
      borderWidth: ['2px', null, '3px'],
      borderColor: 'lightGreen',
      borderRadius: 'sm',
    }}
    {...props}
  />
)

export const PlayingCard: React.SFC<IPlayingCardProps> = ({ card, ...props }) => {
  const rank = card[0] as PlayingCardRank
  const suit = card[1] as PlayingCardSuit
  return (
    <PlayingCardContainer
      sx={{
        bg: 'white',
        fontSize: ['1.2rem', null, null, null, 5],
        lineHeight: 1,
        fontWeight: 'light',
        display: 'inline-flex',
        alignItems: 'center',
        color: suitColorMap[suit],
      }}
      {...props}
    >
      <Box sx={{ width: '100%', textAlign: 'center' }}>
        <Txt sx={{ fontSize: '.9em' }}>{suitUnicodeMap[suit]}</Txt>
        <Txt>{rankOverridesMap[rank] || rank}</Txt>
      </Box>
    </PlayingCardContainer>
  )
}
